function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import cx from "classnames";
import { useUIDSeed } from "react-uid";
import { twMerge } from "../../../utils";
import { CallToAction, Heading, Subheading } from "../../atoms";
import { ArrowRight } from "../../icons";
export var SectionHeader = function(param) {
    var label = param.label, _labelColor = param.labelColor, labelColor = _labelColor === void 0 ? "neutral" : _labelColor, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, title = param.title, _titleAs = param.titleAs, titleAs = _titleAs === void 0 ? "h2" : _titleAs, titleVariant = param.titleVariant, callToActions = param.callToActions, sideContent = param.sideContent, className = param.className;
    var seed = useUIDSeed();
    return /*#__PURE__*/ React.createElement("header", {
        className: twMerge(cx("grid grid-cols-1 grid-flow-row auto-rows-auto items-center gap-5 md:grid-cols-[3fr_2fr]", variant === "centered" && "text-center md:grid-cols-1", variant === "mobile-centered" && "text-center sm:text-left", className))
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid gap-4 grid-cols-1 grid-flow-row auto-rows-auto", variant === "centered" && "max-w-[38rem] mx-auto")
    }, !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: cx(labelColor === "primary" && "text-brand-primary-base", labelColor === "secondary" && "text-brand-secondary-base")
    }, label), !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: titleAs,
        variant: titleVariant !== null && titleVariant !== void 0 ? titleVariant : titleAs
    }, title)), !!callToActions && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("flex flex-wrap items-center justify-end -m-3", variant === "centered" && "justify-center", variant === "mobile-centered" && "justify-center sm:justify-end")
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({}, action, {
            key: seed(action),
            icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
            className: "m-3",
            linkVariant: "big"
        }));
    }))), !callToActions && sideContent);
};

//# sourceMappingURL=SectionHeader.js.map